import { useParams } from 'react-router-dom';
export const useMyLearningParams = () => {
  const {
    tab
  } = useParams();
  return {
    tab: tab !== null && tab !== void 0 ? tab : 'all'
  };
};